import { render, staticRenderFns } from "./vsAvatar.vue?vue&type=template&id=330149ee&lang=html&"
import script from "./vsAvatar.vue?vue&type=script&lang=js&"
export * from "./vsAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsAvatar.vue"
export default component.exports